import Box from '@mui/material/Box';
import { type SxProps } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { type ReactNode, memo } from 'react';
import { getAnimation } from '.';
import { useSettingsContext } from '../../context/settings';
import { type Modules } from '../../modules/_definition/types';

type AnimationProps = {
    children: ReactNode;
    delay?: number;
    direction?: 'none' | '-left' | '-right' | '-up' | '-down';
    disabled?: boolean;
    distance?: number;
    duration?: number;
    module: Modules;
    sx?: SxProps;
    type?: 'fade' | 'flip' | 'slide' | 'zoom-in' | 'zoom-out';
};

function AnimationComponent(props: AnimationProps) {
    const { children, delay = 100, direction = '-down', disabled = false, distance = 0, duration = 500, module, sx = {}, type = 'fade' } = props;
    const settings = useSettingsContext();

    const typeArr: string[] = [type];
    if (direction) typeArr.push(direction);

    const variants = getAnimation({
        direction,
        distance,
        type,
        delay,
        duration,
    });

    const disableAnimation = settings?.style?.noAnimations || settings?.[module]?.noAnimations || disabled;

    return (
        <Box
            component={disableAnimation ? undefined : motion.div}
            sx={sx}
            initial={disableAnimation ? undefined : 'initial'}
            whileInView={disableAnimation ? undefined : 'animate'}
            exit={disableAnimation ? undefined : 'exit'}
            viewport={disableAnimation ? undefined : { once: true, amount: 0 }}
            variants={disableAnimation ? undefined : variants}
        >
            {children}
        </Box>
    );
}

export default memo(AnimationComponent);
